var exports = {
  "PM": "Poll.module__pollContainer___eVhfek",
  "VD": "Poll.module__answerButton___eVhfek",
  "kf": "Poll.module__answerPercentageBar___eVhfek",
  "tQ": "Poll.module__answerLayout___eVhfek",
  "yR": "Poll.module__answerCheckbox___eVhfek",
  "K": "Poll.module__answerMeSuccess___eVhfek",
  "yy": "Poll.module__answerText___eVhfek",
  "wX": "Poll.module__answerTotalVotes___eVhfek",
  "sd": "Poll.module__answerVotes___eVhfek",
  "pz": "Poll.module__answerPercentage___eVhfek",
};

module.exports = exports;
